@use '@/styles/tokens' as *;

.dot {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.dot.info {
  background: $color-info-500;
}
.dot.success {
  background: $color-brand-500;
}
.dot.error {
  background: $color-error-500;
}
.dot.pending {
  background: var(--border-default);
}

.timeline :global(.ant-timeline-item-tail) {
  border-inline-start-color: var(--border-default);
}

.content {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.left {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.title {
  font-size: 14px;
}

.title.info {
  color: $color-info-500;
}
.title.success {
  color: $color-brand-500;
}
.title.error {
  color: $color-error-500;
}
.title.pending {
  color: var(--text-muted);
}

.person {
  display: flex;
  align-items: center;
  gap: 10px;
}

.name {
  font-size: 14px;
  color: var(--text-primary);
}

.timestamp {
  font-size: 11px;
  color: var(--text-disabled);
  text-align: right;
  white-space: nowrap;
}
